import Swiper from 'swiper';
import { Navigation, Autoplay, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const karusellSwiper = {
  init() {
    const wrappers = document.querySelectorAll('.karusell-Wrapper'); // versalt W
    if (!wrappers.length) return;

    wrappers.forEach((wrap) => {
      const container = wrap.querySelector('.karusell-produkter');     // din container
      const slides = container?.querySelectorAll('.swiper-slide') || [];
      if (!container || !slides.length) return;

      const nextEl = wrap.querySelector('.swiper-karusell-button-next');
      const prevEl = wrap.querySelector('.swiper-karusell-button-prev');

      // säkerställ att knapparna hittas
      if (!nextEl || !prevEl) {
        console.warn('Swiper-nav saknas i denna wrapper:', wrap);
        return;
      }

      // eslint-disable-next-line no-new
      new Swiper(container, {
        modules: [Navigation, Autoplay, Mousewheel],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        watchOverflow: true,
        keyboard: { enabled: true },
        mousewheel: { forceToAxis: true },
        autoplay: false,
        navigation: { nextEl, prevEl },
      });
    });
  },
};

export default karusellSwiper;
